// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmbedChess_wrapper__Dl_Xt"};